<template>
<w-setting-sliding-popup ref="slidingPopup" title="계정 동기화" width="750px">
  <div slot="content">
    <el-row class="title-bar vertical-center-box" type="flex" justify="space-between">
      <div class="title-h4">동기화 대상 선택</div>
      <div class="vertical-center-box">
        <el-checkbox class="mr-r10" v-model="syncDateCheck" @change="onDateChange"><span class="mr-r5">동기화 일시</span></el-checkbox>
        <el-date-picker class="mr-r4" :disabled="!syncDateCheck" style="width: 200px" v-model="dateRange" type="daterange" @change="onDateChange" align="right" unlink-panels :range-separator="defaultDateRangeOptions.rangeSeparator" :start-placeholder="defaultDateRangeOptions.startPlaceholder"
          :end-placeholder="defaultDateRangeOptions.endPlaceholder" :picker-options="defaultDateRangeOptions.pickerOptions" :default-time="defaultDateRangeOptions.defaultTime" :clearable="false"></el-date-picker>
        <w-search-field ref="searchField" width="200px" @search="onKeywordSearch" />
      </div>
    </el-row>
    <div class="password-sync-tree">
      <div class="header">
        <div class="cell" style="width:calc(100% - 200px)">
          대상
        </div>
        <div class="cell" style="text-align:center; width:130px;">
          동기화 일시
        </div>
        <div class="cell" style="text-align:center; width:60px;">
          계정
        </div>
      </div>
      <el-tree v-loading="isLoading" :data="treeData" class="tree-checkbox" :load="loadData" :ref="treeRef" default-expand-all :props="defaultProps" :filter-node-method="filterNode" show-checkbox @node-click="onNodeClick" :node-key="defaultProps.treeKey" :expand-on-click-node="false">
        <span class="el-tree-node__label custom-tree-node" slot-scope="{ node, data }"> <!--class="el-tree-node__label"-->
            <el-row v-if="data.objId" style="width:100%;" type="flex" justify="space-between">
              <div>{{getObjNodeLabel(data)}}</div>
              <div>
                <div style="display:inline-block; text-align:center; width:130px;">{{getDateFormatter(data.syncDatetime)}}</div>
                <div style="display:inline-block; text-align:center; width:60px;">{{data.accountCount}}개</div>
              </div>
            </el-row>
            <span v-else>{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
  </div>
  <div slot="footer">
    <el-button size="large" type="solid" @click="onClickAddAccountSync">동기화</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </div>
</w-setting-sliding-popup>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import { defaultDateRangeOptions, getDateToString } from '@/utils/date';
import { getValueAfterCheckEmpty } from '@/utils/string';
import NetdeviceAccountSettingsAPI from '@/api/settings/netdevice/netdevice-account-settings';
import moment from 'moment';
import TreeFilter from '@/mixins/tree/filter';
import { defaultProps } from '@/constants/tree';
import WSearchField from '@/components/form/SearchField';
import msgUtil from '@/utils/message';

export default {
  name: 'WAddAccountSyncSlidingPopup',
  components: {
    WSearchField,
  },
  mixins: [TreeFilter],
  data() {
    const endDatetime = moment()
      .endOf('day')
      .toDate();

    const startDatetime = moment(endDatetime)
      .subtract(1, 'month')
      .startOf('day')
      .toDate();

    return {
      treeRef: 'tree',
      defaultProps,
      treeData: null,
      defaultDateRangeOptions,
      dateRange: [startDatetime, endDatetime],
      syncDateCheck: false,
      selectPhysicalNode: null,
      keyword: null,
      isLoading: false,
    };
  },
  methods: {
    /**
     * 계정 동기화 팝업을 연다.
     */
    open() {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.init();
      });
    },
    /**
     * 계정 동기화 팝업을 닫는다.
     */
    close() {
      this.$refs.slidingPopup.close();
    },
    /**
     * 계정 동기화 팝업을 초기화한다.
     */
    init() {
      this.syncDateCheck = false;
      this.$refs.searchField.clear();
      const endDatetime = moment()
        .endOf('day')
        .toDate();

      const startDatetime = moment(endDatetime)
        .subtract(1, 'month')
        .startOf('day')
        .toDate();
      this.dateRange = [startDatetime, endDatetime];
      this.keyword = null;

      this.loadData();
    },
    /**
     * 네트워크 장비 트리를 로드한다.
     * @author Ju
     */
    loadData() {
      this.isLoading = true;
      NetdeviceAccountSettingsAPI.getPhysicalTreeWithSyncData()
        .then((response) => {
          const result = response.data;
          if (result.success === true) {
            this.treeData = [result.children];
          } else {
            this.treeData = [];
          }
        })
        .catch(() => {
          this.treeData = [];
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * 트리 노드에 대한 라벨을 반환한다.
     * @author Ju
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getObjNodeLabel(data) {
      if (data.obj) {
        const obj = data.obj;
        const ipaddress = obj.ipaddressApplytype === 'IPv6' ? obj.ipaddressIpv6 : obj.ipaddressIpv4;
        return `${data.label} (${getValueAfterCheckEmpty(ipaddress)})`;
      }
      return data.label;
    },
    /**
     * 트리 노드에 대한 동기화 일시를 반환한다.
     * @author Ju
     * @param  {[type]} value [description]
     * @return {String}
     */
    getDateFormatter(value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return '동기화 이력 없음';
    },
    /**
     * 트리 노드를 조건에 맞게 필터링한다.
     * @author Ju
     * @param  {[type]} value [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     */
    filterNode(value, data) {
      const filterNodeByKeyword = (keyword, nodeData) => {
        if (!keyword) return true;
        if (isEmpty(nodeData.ipaddress)) {
          return nodeData.label.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
        }

        // IP 정보가 있는 경우 IP도 함께 검색한다.
        const lowerKeyword = keyword.toLowerCase();
        return nodeData.label.toLowerCase().indexOf(lowerKeyword) !== -1 || (!isEmpty(nodeData.ipaddress) && nodeData.ipaddress.toLowerCase().indexOf(lowerKeyword) !== -1);
      };

      if (this.syncDateCheck === true) {
        const validDate = !isNil(data.syncDatetime) && (data.syncDatetime >= this.dateRange[0] && data.syncDatetime <= this.dateRange[1]);
        return validDate && filterNodeByKeyword(value, data);
      }
      return filterNodeByKeyword(value, data);
    },
    /**
     * 기간 조건 변경 이벤트 핸들러
     * @author Ju
     */
    onDateChange() {
      this.filterTree(this.keyword);
    },
    /**
     * 트리 노드 클릭 이벤트 핸들러
     */
    onNodeClick(data) {
      this.selectPhysicalNode = data;
    },
    /**
     * 키워드 검색 이벤트 핸들러
     * @author Ju
     * @param  {[type]} value [description]
     */
    onKeywordSearch(value) {
      this.keyword = value;
      this.filterTree(value);
    },
    onClickAddAccountSync() {
      // obj들만 보내도록한다. map을 통해서 obj들만 list에 담아 보내자.
      const objIds = [];
      const checkedNodes = this.$refs.tree.getFilteredCheckedNodes();
      if (!isEmpty(checkedNodes)) {
        forEach(checkedNodes, (item) => {
          if (item.objId) {
            objIds.push({ objId: item.objId });
          }
        });

        NetdeviceAccountSettingsAPI.deviceAccountSync(objIds).then((response) => {
          if (response.data.success) {
            this.$emit('get-status-by-sync-hist', response.data.data);
            // this.getStatusBySyncHist(response.data.data); // histSeq 전달
            // this.$emit('sync-status-info', 'N');
            this.close();
          }
        });
      } else {
        this.$message(msgUtil.getRequireMsgData(msgUtil.action.SELECT, '계정을 동기화할 장비', false));
      }
    },
  },
};
</script>

<style lang="scss">
.password-sync-tree {
  .header {
    width: 100%;
    border-top: 1px solid #888; //$chinagray
    /* border-bottom: 1px solid #e5e5e5; */
    background: #eee; //$palegray

    .cell {
      display: inline-block;
      color: #6b7079;
      font-weight: 400;
      padding: 5px 15px;
    }
  }

  .el-tree-node__content {
    background-color: #fff !important;

    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .cell {
      display: inline-block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/DeviceAccountSettings/AccountSynchronization/popup/AddAccountSyncSlidingPopup.vue